// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__z4eIn","boxTitle":"Qualiphy_boxTitle__3KdmP","box":"Qualiphy_box__2kmCR","toggleWrap":"Qualiphy_toggleWrap__1h5dz"};